import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: 'network',
    redirect: { name: 'federated-visualisation' },
  },
  {
    path: 'network/visualisation',
    name: 'federated-visualisation',
    component: () => import('./FederatedNetwork.vue'),
  },
  {
    path: 'network/table',
    name: 'federated-table',
    component: () => import('./FederatedNetworkTablePage.vue'),
  },
] satisfies RouteRecordRaw[];
